export function getAssetUrl(asset: string) {
  return 'https://api.binnar.com.pl' + asset;
}
